export default {
  s: '%d saniye',
  smicro: '%d sn',
  smid: '%d sn',

  ss: '%d saniye',
  ssmicro: '%d sn',
  ssmid: '%d sn',

  m: '%d dakika',
  mmicro: '%d dk',
  mmid: '%d dk',

  mm: '%d dakika',
  mmmicro: '%d dk',
  mmmid: '%d dk',

  h: '%d saat',
  hmicro: '%d saat',
  hmid: '%d saat',

  hh: '%d saat',
  hhmicro: '%d saat',
  hhmid: '%d saat',

  d: '%d gün',
  dmicro: '%d gün',
  dmid: '%d gün',

  dd: '%d gün',
  ddmicro: '%d gün',
  ddmid: '%d gün',
};
